export const sites = [
  "se",
  "dk",
  "fi",
  "no",
  "hr",
  "fr",
  "it",
  "es",
  "de",
  "nl",
  "us",
  "uk",
  "cn",
  "com",
  "stage"
] as const;
export type Site = (typeof sites)[number];
